<script>
	import { SupportUser,Response,isFormAlreadySubmitted} from "./store.js";
	import wrappedFetch from "../../wrappedFetch.js";
	import {User} from "../../store.js";
	import Step1 from "./step1.svelte";
	import Step2 from "./step2.svelte";
	import Step3 from "./step3.svelte";
	
	import Summary from "./summary.svelte";
	import { onMount, createEventDispatcher } from "svelte";
	const dispatch = new createEventDispatcher();
	const getAuthUser = async () => {
		let resp = await wrappedFetch("/user/GetAuthUser", { method: "post" });
		return await resp.json();
	};
	let Route;
  let steps = ["Step 1", "Step 2", "Step 3"];
  let isPageLoading = true;
let showProgressbar = !isFormAlreadySubmitted();
  window.onbeforeunload = function() {    
        return "Are you sure you want to leave? By leaving, changes to this form will be lost. ";
    };
  export let activeStep;
  export let supportId;
	$: {
		switch (activeStep) {
			case "step1":			
				Route = Step1;
				break;
			case "step2":	
				Route = Step2;
				break;
			case "step3":     
				Route = Step3;
				break;		
		}
	}
	onMount(async () => {
		//SupportUser.set((await getAuthUser()).user);
    isPageLoading=false;
	});
</script>

<svelte:head>
	<title>Further Feedback | eAdmissions</title>
</svelte:head>
<section class="section">
	<div class="container">
		<div class="columns is-centered is-desktop">
			<div class="column is-10-desktop">
				<div class="table-container">
					{#if activeStep != 'summary' && showProgressbar}
						<ul
							class="steps is-balanced has-content-centered is-horizontal"
							style="list-style:none;">
							{#each steps as step}
								<li class="steps-segment {step.replace(' ','').toLowerCase() == activeStep ? 'is-active' : ''}">
									<span class="steps-marker" style="cursor:default;"></span>
									<div class="steps-content">
									<span style="color: inherit; cursor:default;" class="is-size-4">
										{step}
									</span>
									</div>
								</li>
							{/each}
						</ul>
          {/if}
          {#if !isPageLoading}
					<svelte:component
            this={Route}
            {supportId}
            on:pageChange={(event) => dispatch('pageChange', event.detail)}
            on:checkCookie={()=>showProgressbar = false}
          />
            {/if}
				</div>
			</div>
		</div>
	</div>
</section>
